<template>
<div class="m-3">
  <b-row>
    <b-col cols="9">
      <ListLoader v-if="showLoader"
        :speed="2"
        :animate="true"
        class="loader"
       ></ListLoader>

      <div class="svgcontainer" ref="container" v-if="nodes && nodes.length >= 1">

      <panZoom
        class="pz"
        @panstart="onPanZoomStart"
        @zoom="onPanZoomStart"
        selector="#graphdiv svg"
        :options="{
          bounds: true,
          boundsPadding: 0.1
        }"
        >
            <d3-network
              :net-nodes="nodes"
              :net-links="links"
              :selected="selected"
              :selection="{nodes: selectedNodes, links: selectedLinks}"
              :options="options"
              :nodeCb="nodeFormatter"
              :linkCb="linkFormatter"
              :simCb="simulationFormatter"
              @node-click='changeNode'
              @node-hover='changeNode'
              id="graphdiv"
              :class="font"
            >
            </d3-network>
      </panZoom>
      </div>
    </b-col>

    <b-col cols="3">
        <!-- search/node details -->
        <div>
          <b-button variant="primary" size="sm" v-on:click.prevent="resetGraph" class="float-right">
            Reset
          </b-button>
          <h3>
          <span v-if="searchQuery">
            <b-badge class="mr-2" variant="light">search query</b-badge><br>
            <div class="mt-2" variant=light>{{searchQuery | truncate(100, '...')}}</div>
          </span>
          <!--
          <span v-if="nodeId">
            <b-badge class="mr-2" variant="light">node</b-badge><br>
            <div class="mt-2" ><span v-if="nodeTitle">{{nodeTitle}} // </span> {{nodeId}}</div>
          </span>
          -->
          </h3>

          <div class="mt-3">
            Graph contains <b>{{topicNodes.length}} topics</b> <span v-if="maxSearchResults"> (total of: {{maxSearchResults}} results)</span><br>
            <b-badge v-if="this.withFilters" variant="warning"> filters active from last search</b-badge>
          </div>
        </div>

        <div class="mt-5">
        <label><strong>Select topic or concept</strong></label>
        <multiselect
          v-model="selected"
          :options="nodes"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="true"
          :hide-selected="false"
          :searchable="true"
          :preserve-search="true"
          :internalSearch="true"
          :showPointer="true"
          :showLabels="false"
          label="Title"
          track-by="Title"
          :preselect-first="false"
          @select="onSelect"
          @remove="deselectNode"
          >
            <template slot="singleLabel" slot-scope="props">
              <span class="option__title">
                <b-badge class="mr-1" v-if="props.option.type=='CONCEPT'" variant="light">{{ props.option.type }}</b-badge>
                <strong>{{ props.option.Title }}</strong></span>
            </template>

            <template slot="option" slot-scope="props">
              <span class="option__title">
              <b-badge class="mr-1" v-if="props.option.type=='CONCEPT'" variant="light">{{ props.option.type }}</b-badge>
              {{ props.option.Title }}</span>
            </template>

            <template slot="tag">{{ '' }}</template>
          </multiselect>

        <div class="mt-4">
          <NodeDetail v-if="selected" v-bind:node="selected" :key="selected.index" @nodeChanged="nodeChanged" @nodeExpansion="nodeExpansion"></NodeDetail>
        </div>
        </div>

        <b-button v-if="nodes && nodes.length >= 1" v-on:click.prevent="fetchTopicsAndGoToSearch" class="fw mt-3">
          Show all topics in search
        </b-button>

        <div class="settings mt-5" v-if="nodes && nodes.length >= 1">

          <b-button v-b-toggle.grsettings variant="light">
              <strong>Graph settings</strong>
               <span class="when-opened">
                   <v-icon name="chevron-down" class="vicon"></v-icon>
               </span>
               <span class="when-closed">
                  <v-icon name="chevron-right" class="vicon"></v-icon>
               </span>
          </b-button>
          <b-collapse id="grsettings" class="mt-3">
          <b-form-checkbox v-model="options.nodeLabels"
          @change="nodeLabelsChanged">
            <em>Show node labels</em>
          </b-form-checkbox>

          <div class="mt-2">
            <label class="mt-2"><em>Font size</em></label>
            <vue-slider
              v-model="font"
              :data="fonts"
              :marks="true"
              class="sl mb-3"
              :contained="true"
            ></vue-slider>
          </div>

          <div class="mt-4">
            <label class="mt-2"><em>#topics (when searching)</em></label>
            <vue-slider
              v-model="rows"
              :adsorb="true"
              :min="20"
              :max="100"
              :interval="10"
              :included="true"
              :marks="true"
              class="sl mb-3"
              @change="rowsChanged"
              :contained="true"
            ></vue-slider>
          </div>

          <div class="mt-4">
            <label class="mt-2"><em>force</em></label>
            <vue-slider
              class="sl mb-3"
              v-model="options.force"
              :interval="100"
              :min="100"
              :max="2000"
              :included="true"
              :absorb="true"
              @change="forceChanged"
              :contained="true"
            ></vue-slider>
          </div>
          </b-collapse>

<!--
          <div class="mt-4">
            <b-button v-b-modal.futurefeatures class="mr-1" variant="dark" size="sm">
              More <v-icon name="settings" class="vicon"></v-icon>
            </b-button>
            <b-button v-b-modal.futurefeatures class="mr-1" variant="dark" size="sm">
              Export <v-icon name="image" class="vicon"></v-icon>
            </b-button>
            <b-button v-b-modal.futurefeatures class="mr-1" variant="dark" size="sm">
              Export <v-icon name="list" class="vicon"></v-icon>
            </b-button>
            <b-button v-b-modal.futurefeatures class="mr-1" variant="dark" size="sm">
              Share <v-icon name="share-2" class="vicon"></v-icon>
            </b-button>
          </div>
-->
        </div>


    </b-col>
  </b-row>

</div>
</template>

<script>
import D3Network from 'vue-d3-network';
import NodeDetail from './NodeDetail';
import { ListLoader } from 'vue-content-loader';
import Multiselect from 'vue-multiselect';

export default {
  components: {
    D3Network,
    NodeDetail,
    ListLoader,
    Multiselect
  },
  name: 'graphvisualization',
  data () {
    return {
      searchQuery: '',
      maxSearchResults: '',
      withFilters: false,
      nodeId: '',
      nodeTitle: '',
      options: {
          force: '',
          nodeSize: 10,
          nodeLabels: true,
          linkLabels:false,
          dragging: false,
          linkWidth:2,
          forces: {
            Center: true,
            X: 0.2,
            Y: 0.2,
            Link: true,
            ManyBody: true
          }
      },
      selected: '',
      selectedNodes: {},
      selectedLinks: {},
      rows: '',
      font: 'small',
      fonts: ['small', 'medium', 'large'],
      showLoader: false
    }
  },
  created: function () {
    this.options.force = this.force;
    this.rows = this.graphSettings.rows;
    this.options.nodeLabels = this.graphSettings.showNodeLabels;
    this.options.linkLabels = this.graphSettings.showLinkLabels;

    if( this.$router.currentRoute.query && this.$router.currentRoute.query.q != undefined && this.$router.currentRoute.query.q != '') {
      this.searchQuery = this.$router.currentRoute.query.q;

    } else if( this.$router.currentRoute.query && this.$router.currentRoute.query.id != undefined &&  this.$router.currentRoute.query.id != '') {
      this.nodeId = this.$router.currentRoute.query.id;
    }

    if( this.$router.currentRoute.params && this.$router.currentRoute.params.nodeTitle ) {
      this.nodeTitle = this.$router.currentRoute.params.nodeTitle;
    }

  },
  filters: {
    truncate: function (text, length, suffix) {
      if( text && text.length > length )
        return text.substring(0, length) + suffix;
      else
        return text;
    }
  },
  computed: {
    nodes () {
      return (this.$store.state.graph.nodes )
        ? (this.$store.state.graph && this.$store.state.graph.nodes) : [];
    },
    topicNodes () {
       return this.nodes.filter( n => {
           return n.type == 'DOC';
           })
    },
    links () {
      return (this.$store.state.graph.links )
        ? (this.$store.state.graph && this.$store.state.graph.links) : [];
    },
    response () {
      return (this.$store.state.response)
        ? this.$store.state.response : null;
    },
    prefetchedResults () {
      return (this.$store.state &&
          this.$store.state.suggest &&
          this.$store.state.suggest.response &&
          this.$store.state.suggest.response.prefetchedResults ) ?
          this.$store.state.suggest.response.prefetchedResults : null;
    },
    activefilters () {
      if (this.$store.state.response &&
          this.$store.state.response.active_filters) {
        return this.$store.state.response.active_filters
      }
      return null;
    },
    force () {
      if (this.$store.state.graphSettings && this.$store.state.graphSettings.force ) {
        return this.$store.state.graphSettings.force;
      }
      return null;
    },
    graphSettings () {
      if (this.$store.state.graphSettings ) {
        return this.$store.state.graphSettings;
      }
      return null;
    }
  },
  methods: {
    onPanZoomStart: function() {
      var s = this.$el.querySelector("svg");
      if( s ) {
        var bbox = s.getBBox();
        if( bbox.width > s.clientWidth ) {
          s.setAttribute("width", bbox.width);
        }
        if( bbox.height > s.clientHeight ) {
          s.setAttribute("height", bbox.height);
        }
      } else {
        //console.log("svg undefined")
      }
    },
    nodeFormatter: function(node) {
      node.name = (node.Title && node.Title.length  > 16) ? node.Title.substring(0,16)+'...' : node.Title;
      return node;
    },
    linkFormatter: function(link) {
      return link;
    },
    simulationFormatter: function(sim) {
      sim.alpha(0.5).restart();
      return sim;
    },
    changeNode: function (event, node) {
      if(this.selected) {
        if( node && node.id != this.selected.id ) {
          this.selected = this.nodes[node.index];
          this.selectedNodes = {};
          this.selectedNodes[node.id] = node;

          this.selectedLinks = {};
          for (let link of this.links) {
            if (this.selectedNodes[link.sid] || this.selectedNodes[link.tid]) {

              this.$set(this.selectedLinks, link.id, link)
            } else {
            if (this.selectedLinks[link.id]) {
              delete (this.selectedLinks[link.id])
            }
            }
          }
        }
      } else {
        if( node && node.id ) {
          this.selected = this.nodes[node.index];
          this.selectedNodes = {};
          this.selectedNodes[node.id] = node;

          this.selectedLinks = {};
          for (let link of this.links) {
            if (this.selectedNodes[link.sid] || this.selectedNodes[link.tid]) {

              this.$set(this.selectedLinks, link.id, link)
            } else {
            if (this.selectedLinks[link.id]) {
              delete (this.selectedLinks[link.id])
            }
            }
          }
        }
      }

    },
    deselectNode: function () {
      this.selected = '';
      this.selectedNodes = {};
      this.selectedLinks = {};
    },
    resetGraph: function () {
      if( this.searchQuery != '' ) {
        this.withFilters = false;
        this.maxSearchResults = '';
        return this.$store.dispatch('fetchGraphByQuery', { 'query': this.searchQuery, 'withFilters': false } )
      }
      if( this.nodeId && this.nodeId != '' ) {
        return this.$store.dispatch('fetchGraphByNode', this.nodeId)
      }
    },
    nodeChanged: function (newId) {
      this.nodeId = newId;
      this.searchQuery = '';
      this.withFilters = false;
      this.maxSearchResults = '';
    },
    nodeExpansion: function (newId) {
      if( newId != '' ) {
        return this.$store.dispatch('expandGraphByNode', newId)
      }
    },
    linkLabelsChanged: function (e) {
      this.options.linkLabels = e;
      this.options = Object.assign({}, this.options);
      this.$store.commit('updateGraphSettings', { 'force': this.options.force, 'rows': this.rows, 'showLinkLabels': this.options.linkLabels, 'showNodeLabels': this.options.nodeLabels }  );
    },
    nodeLabelsChanged: function (e) {
      this.options.nodeLabels = e;
      this.options = Object.assign({}, this.options);
      this.$store.commit('updateGraphSettings', { 'force': this.options.force, 'rows': this.rows, 'showLinkLabels': this.options.linkLabels, 'showNodeLabels': this.options.nodeLabels }  );
    },
    onSelect(node){
      this.changeNode(null,node);
    },
    fetchTopicsAndGoToSearch() {
      var str = "";
      for(var i in this.topicNodes) {
        if(i == 0) str += 'id:("' + this.topicNodes[i].id + '" ';
        if(i>0) str += '"' + this.topicNodes[i].id + '" ';
        if(i==this.topicNodes.length-1) str += ")";
      }
      this.$router.push({name: 'home', query: { q: str } });
    },
    forceChanged: function (e) {
      this.options.force = e;
      this.options = Object.assign({}, this.options);
      this.$store.commit('updateGraphSettings', { 'force': this.options.force, 'rows': this.rows, 'showLinkLabels': this.options.linkLabels, 'showNodeLabels': this.options.nodeLabels }  );
    },
    rowsChanged: function () {
      this.$store.commit('updateGraphSettings', { 'force': this.options.force, 'rows': this.rows, 'showLinkLabels': this.options.linkLabels, 'showNodeLabels': this.options.nodeLabels }  );
      this.resetGraph();
    },
  },
  watch: {
    nodeId: function (newId) {
      if( newId != '' ) {
        return this.$store.dispatch('fetchGraphByNode', newId)
      }
    },
    nodes: function (newNodes) {

      if( newNodes && newNodes.length > 0 ) {
        this.showLoader = false;
      }
      else {
        this.showLoader = true;
      }
    },
    searchQuery: function (newQuery) {
      if( newQuery != '' ) {
        this.withFilters = false;

        if( this.response && this.response.context && this.response.context.processedSearchTerms == newQuery ) {
          this.maxSearchResults = this.response.response.numFound;
        }
        else {
          this.maxSearchResults = '';
        }

        if( this.response && this.response.context && this.response.context.processedSearchTerms == newQuery && this.activefilters.filters ) {
          this.withFilters = true;
        }

        return this.$store.dispatch('fetchGraphByQuery', { 'query': this.searchQuery, 'withFilters': this.withFilters })
      }
    }
  }
}
</script>

<style scoped>
.loader{
  width: 100%;
  height: 600px;
}
#graphdiv {
  overflow:hidden;
  max-height: 88vh;
  min-height: 88vh;
}
.pz {
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.fw {
  width:100%;
}
.settings {
  //position:absolute;
  //bottom:10px;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
    display: none;
}
</style>
